export default __webpack_public_path__ + "static/media/4.def5687a.gif";